import noop from 'lodash-es/noop'
import * as React from 'react'

import { Output as AddToBagOutput } from '../../../../../../lib/hooks/useBag'

import { Template } from './Template'
import { useViewModel } from './useViewModel'

interface Props {
  isPortalColorSelected?: boolean
  resetInvalidBagClickStatus?: AddToBagOutput['resetInvalidBagClickStatus']
}

export const EmbroiderySummary: React.FC<Props> = ({
  isPortalColorSelected = false,
  resetInvalidBagClickStatus = noop,
}) => {
  const viewModel = useViewModel({ isPortalColorSelected, resetInvalidBagClickStatus })

  return <Template {...viewModel} />
}
